import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Colors, Metrics } from '../../../Themes'
import BaseButton from './BaseButton'

export default class GhostButton extends Component {

  static propTypes = {
    buttonText: PropTypes.string.isRequired,
    onPress: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    icon: PropTypes.string,
    iconSize: PropTypes.string,
    buttonStyle: PropTypes.object,
    customButtonStyle: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array
    ]),
    customIconStyle: PropTypes.object,
    withIndicator: PropTypes.bool,
    indicatorColor: PropTypes.string,
    fetching: PropTypes.bool
  }

  static defaultProps = {
    buttonText: null,
    onPress: null,
    disabled: null,
    icon: 'delete',
    iconSize: Metrics.icons.regular,
    buttonStyle: { borderColor: Colors.theme1, margin: Metrics.baseMargin + ' 0' },
    customButtonStyle: {},
    customIconStyle: {},
    withIndicator: false,
    indicatorColor: Colors.theme1,
    fetching: false
  }

  render = () => {
    return (
      <BaseButton
        variant={'outlined'}
        buttonText={this.props.buttonText}
        onPress={this.props.onPress}
        disabled={this.props.disabled}
        icon={this.props.icon}
        iconSize={this.props.iconSize}
        iconStyle={Object.assign({}, { color: Colors.theme1 }, this.props.customIconStyle)}
        buttonStyle={Object.assign({}, this.props.buttonStyle, this.props.customButtonStyle)}
        withIndicator={this.props.withIndicator}
        indicatorColor={this.props.indicatorColor}
        fetching={this.props.fetching}
      />
    )
  }

}
